module.exports = __webpack_public_path__ + "img/36.cd8cf210.jpg";